import { createStylesParams, StyleParamType } from '@wix/tpa-settings';

export type LayoutStylesParams = {
  sectionImageHeight: StyleParamType.Number;
  headerImageHeight: StyleParamType.Number;
  appHorizontalPadding: StyleParamType.Number;
  itemImageVerticalPadding: StyleParamType.Number;
  itemImageHorizontalPadding: StyleParamType.Number;
};

export const layoutStylesParams = createStylesParams<LayoutStylesParams>({
  sectionImageHeight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 320,
  },
  itemImageVerticalPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  itemImageHorizontalPadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  headerImageHeight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 320,
  },
  appHorizontalPadding: {
    type: StyleParamType.Number,
    getDefaultValue: ({ isMobile }) => (isMobile ? 0 : 24),
  },
});
